<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>
          <feather-icon icon="FilterIcon" /> Filtros
        </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <label>Rol</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="rolFilter"
              :options="rolOptions"
              class="w-100"
              :reduce="val => val.rol"
              label="rol"
              @input="(val) => $emit('update:rolFilter', val)"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <label>Grupo</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="grupoFilter"
              :options="grupoOptions"
              class="w-100"
              :reduce="val => val.nombre"
              label="nombre"
              @input="(val) => $emit('update:grupoFilter', val)"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <label>Estado</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="statusFilter"
              :options="statusOptions"
              class="w-100"
              :reduce="val => val.value"
              @input="(val) => $emit('update:statusFilter', val)"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BOverlay,
  },
  props: {
    rolFilter: {
      type: [String, null],
      default: null,
    },
    grupoFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    rolOptions: {
      type: Array,
      required: true,
    },
    grupoOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
